// extracted by mini-css-extract-plugin
module.exports = {"columns-3":"1700","columns-2":"1550","columns-1":"1350","modalAlert":"errors_modalAlert__1_UUw","exclamationIcon":"errors_exclamationIcon__Md3nm"};